import { RouteObject } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { LoadingSpinner } from '@/components/ui/loading-spinner';
import { ProtectedRoute } from '@/components/ProtectedRoute';

const JobsBoard = lazy(() => import('@/pages/tutor/JobsBoard'));
const JobDetails = lazy(() => import('@/pages/tutor/JobDetails'));
const ActiveJob = lazy(() => import('@/pages/tutor/ActiveJob'));
const Applications = lazy(() => import('@/pages/tutor/Applications'));
const TutorHistory = lazy(() => import('@/pages/tutor/History'));
const TutorPayments = lazy(() => import('@/pages/tutor/Payments'));
const TutorExpenses = lazy(() => import('@/pages/tutor/Expenses'));
const TutorJobs = lazy(() => import('@/pages/tutor/Jobs'));
const TutorReports = lazy(() => import('@/pages/tutor/Reports'));
const ReportDetail = lazy(() => import('@/pages/tutor/ReportDetail'));
const Resources = lazy(() => import('@/pages/tutor/Resources'));

export const tutorRoutes: RouteObject[] = [
  {
    path: 'tutor',
    children: [
      {
        path: 'jobs-board',
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<LoadingSpinner size="md" />}>
                <ProtectedRoute allowedRoles={['tutor']}>
                  <JobsBoard />
                </ProtectedRoute>
              </Suspense>
            ),
          },
          {
            path: ':id',
            element: (
              <Suspense fallback={<LoadingSpinner size="md" />}>
                <ProtectedRoute allowedRoles={['tutor']} allowKey>
                  <JobDetails />
                </ProtectedRoute>
              </Suspense>
            ),
          },
        ],
      },
      {
        path: 'jobs',
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<LoadingSpinner size="md" />}>
                <ProtectedRoute allowedRoles={['tutor']}>
                  <TutorJobs />
                </ProtectedRoute>
              </Suspense>
            ),
          },
          {
            path: ':id',
            element: (
              <Suspense fallback={<LoadingSpinner size="md" />}>
                <ProtectedRoute allowedRoles={['tutor']}>
                  <ActiveJob />
                </ProtectedRoute>
              </Suspense>
            ),
          },
        ],
      },
      {
        path: 'applications',
        element: (
          <Suspense fallback={<LoadingSpinner size="md" />}>
            <ProtectedRoute allowedRoles={['tutor']}>
              <Applications />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: 'history',
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<LoadingSpinner size="md" />}>
                <ProtectedRoute allowedRoles={['tutor']}>
                  <TutorHistory />
                </ProtectedRoute>
              </Suspense>
            ),
          },
          {
            path: 'payments',
            element: (
              <Suspense fallback={<LoadingSpinner size="md" />}>
                <ProtectedRoute allowedRoles={['tutor']}>
                  <TutorPayments />
                </ProtectedRoute>
              </Suspense>
            ),
          },
          {
            path: 'expenses',
            element: (
              <Suspense fallback={<LoadingSpinner size="md" />}>
                <ProtectedRoute allowedRoles={['tutor']}>
                  <TutorExpenses />
                </ProtectedRoute>
              </Suspense>
            ),
          },
        ],
      },
      {
        path: 'reports',
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<LoadingSpinner size="md" />}>
                <ProtectedRoute allowedRoles={['tutor']}>
                  <TutorReports />
                </ProtectedRoute>
              </Suspense>
            ),
          },
          {
            path: ':id',
            element: (
              <Suspense fallback={<LoadingSpinner size="md" />}>
                <ProtectedRoute allowedRoles={['tutor']}>
                  <ReportDetail />
                </ProtectedRoute>
              </Suspense>
            ),
          },
        ],
      },
      {
        path: 'resources',
        element: (
          <Suspense fallback={<LoadingSpinner size="md" />}>
            <ProtectedRoute allowedRoles={['tutor']}>
              <Resources />
            </ProtectedRoute>
          </Suspense>
        ),
      },
    ],
  },
];
